<template>
  <div class="section-edit">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="editForm" :model="model"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="model.name" disabled placeholder="输入名称" />
          </FormItem>
          <FormItem label="是否显示标题" prop="showTitle">
            <i-switch v-model="model.showTitle"></i-switch>
          </FormItem>
          <FormItem label="标题" prop="title">
            <Input v-model="model.title" placeholder="输入名称" />
          </FormItem>
          <FormItem label="是否为附件" prop="isAttachment">
            <i-switch v-model="model.isAttachment"></i-switch>
          </FormItem>
          <FormItem label="是否为企业自评项" prop="isSelfAppraise">
            <i-switch v-model="model.isSelfAppraise"></i-switch>
          </FormItem>
          <FormItem label="总分" prop="totalScore">
            <InputNumber v-model="model.totalScore" placeholder="输入总分" />
          </FormItem>
          <FormItem label="评分表达式" prop="scoreFormula">
            <Input v-model="model.scoreFormula" placeholder="输入评分表达式" />
            <span><a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">https://mathjs.org/docs/expressions/syntax.html</a></span>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'question-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      model: {
        id: null,
        name: null,
        title: null,
        isAttachment: null,
        isSelfAppraise: null,
        showTitle: null,
        scoreFormula: null,
        totalScore: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getDetail () {
      if (this.$route.params.id) {
        this.loading = true
        this.$Spin.show()
        Api.Appraisal.getAppraisalSection(this.$route.params.id).then((payload) => {
          this.model = payload
          this.model.id = payload.tid
          this.loading = false
          this.$Spin.hide()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
      }
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Appraisal.editAppraisalSection(this.model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
